import hres85uLabels from 'assets/labels/hres85u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres85uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        place: faker.address.country(),
        dteperiod: moment().format('DD/MM/YYYY HH:mm') + ' - ' + moment().format('DD/MM/YYYY HH:mm'),
        amtreq: faker.commerce.price(),
        remark: 'Test System',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remarkap: 'Test System',
        desc_codempap: faker.name.findName(),
        amtappr: '',
        staappr: '',
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        typepay: '1',
        numperiod: '',
        dtepay: '',
        dtemthpay: '',
        dteyrepay: '',
        codpay: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      dtereq: moment().format('DD/MM/YYYY'),
      place: faker.address.country(),
      desc_codcnty: faker.address.country(),
      distance: faker.commerce.price(),
      costkms: faker.commerce.price(),
      costday: faker.commerce.price(),
      remark: 'Test System',
      dtestrt: moment().format('DD/MM/YYYY'),
      timstrt: moment().format('HH:mm'),
      dteend: moment().format('DD/MM/YYYY'),
      timend: moment().format('HH:mm'),
      qtyday: faker.random.number().toString().substr(0, 1),
      amtreq: faker.commerce.price(),
      filenam1: faker.lorem.word(),
      path_filenam1: faker.lorem.word(),
      filenam2: faker.lorem.word(),
      path_filenam2: faker.lorem.word(),
      filenam3: faker.lorem.word(),
      path_filenam3: faker.lorem.word(),
      descnote: 'Test System'
    }
    let mockTab2Rows = []
    let codexp = ''
    const mockCodexp = [ '0001', '0002', '0003', '0004' ]
    const mockDescCodexp = {
      '0001': 'ค่าที่พัก',
      '0002': 'ค่าอาหาร',
      '0003': 'ค่าน้ำมัน',
      '0004': 'ค่าทางด่วน'
    }
    const mockTab2Total = 4
    for (var a = 1; a <= mockTab2Total; a++) {
      codexp = mockCodexp[Math.floor(Math.random() * 4)]
      mockTab2Rows.push({
        id: a,
        codexp: codexp,
        desc_codexp: mockDescCodexp[codexp],
        amtreq: faker.commerce.price()
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      }
    }
  },
  dropdowns () {
    const mockCodpay = {
      '01': '01 - Salary',
      '02': '02 - Position',
      '03': '03 - Grade Allow',
      '04': '04 - Supervisory Support Allow',
      '05': '05 - ค่าครองชีพ',
      '06': '06 - ค่าวิชาชีพ',
      '07': '07 - เงินเบิกล่วงหน้า',
      '10': '10 - จ้างทำของ',
      '11': '11 - ค่าล่วงเวลา',
      '12': '12 - ค่าเบี้ยขยันรายเดือน',
      '13': '13 - ค่าเบี้ยขยันรายสัปดาห์',
      '14': '14 - ค่าอาหาร',
      '15': '15 - ค่าอาหาร (ล่วงเวลา) บ.ออกให้',
      '16': '16 - ค่าเบี้ยเลี้ยงพิเศษออกให้ครั้งเดียว',
      '17': '17 - ค่ารายได้อื่น-ญี่ปุ่น -Tax',
      '18': '18 - ค่าอยู่เวรพิเศษ บ.ออกให้',
      '19': '19 - ค่าบ้านและโรงเรียน(ออกภาษีให้)',
      '20': '20 - ค่ากะ',
      '21': '21 - เงินพิเศษ (สูตรคำนวณ)',
      '22': '22 - เงินปีใหม่',
      '23': '23 - ค่าเช่าบ้าน (บริษัทออกภาษีให้)',
      '24': '24 - ประกันสังคมบริษัทออกให้',
      '30': '30 - ค่า Commision',
      '31': '31 - โบนัส',
      '32': '32 - เงินได้จ่ายครั้งเดียว',
      '33': '33 - รายได้อื่นๆ Cal.Tax',
      '34': '34 - ค่าเหลื่อมเวลา',
      '35': '35 - เงินได้จาก Japan',
      '36': '36 - เงินเกษียณอายุ',
      '3A': '3A - ค่าชำนาญการ',
      '3B': '3B - ค่าเปื้อนน้ำมัน',
      '3C': '3C - ค่ารถ (Transportation)',
      '3D': '3D - ค่าชุด (Uniform)',
      '3E': '3E - ค่าที่พักอาศัย (ชั่วคราว)',
      '3F': '3F - ค่าชุดสม๊อก',
      '3G': '3G - ค่านายหน้า',
      '3H': '3H - เงินได้จ่ายนอกระบบ',
      '3I': '3I - เงินได้จ่ายนอกระบบ ไม่มีคู่ภาษี',
      '41': '41 - เบี้ยเลี้ยงพิเศษ',
      '42': '42 - จ่ายคืนขาดงาน',
      '43': '43 - จ่ายคืนหักสาย',
      '44': '44 - จ่ายคืนกลับก่อน',
      '45': '45 - จ่ายคืนลาพักร้อน',
      '51': '51 - รายได้อื่นๆ ประจำ (คำนวณภาษี)',
      '52': '52 - รายได้อื่นๆ ประจำ (ไม่คำนวณภาษี)',
      '53': '53 - รายได้อื่นๆ ไม่ประจำ (คำนวณภาษี)',
      '54': '54 - รายได้อื่นๆ ไม่ประจำ (ไม่คำนวณภาษี)',
      '55': '55 - รายได้หักยอดภาษี',
      '61': '61 - หักเงินกู้',
      '62': '62 - หักกู้ที่อยู่อาศัย',
      '63': '63 - หักทำความผิด',
      '64': '64 - สมาชิกสหภาพ',
      '81': '81 - หักขาดงาน',
      '82': '82 - หักลาเกินกำหนด',
      '83': '83 - หักสาย',
      '84': '84 - หักกลับก่อน',
      '86': '86 - หักบังคับคดี15%',
      '91': '91 - รายหักอื่นๆ ประจำ (คำนวณภาษี)',
      '92': '92 - รายหักอื่นๆ ประจำ (ไม่คำนวณภาษี)',
      '93': '93 - รายหักอื่นๆ ไม่ประจำ (คำนวณภาษี)',
      '94': '94 - รายหักอื่นๆ ไม่ประจำ (ไม่คำนวณภาษี)',
      '99': '99 - ค่า Commission',
      'B1': 'B1 - ค่ารักษาพยาบาลจ่ายคืนพนักงาน',
      'B2': 'B2 - หักคืนค่ารักษาพยาบาล',
      'B3': 'B3 - เงินเบิกสวัสดิการอื่น ๆ',
      'B4': 'B4 - เงินหักเบี้ยประกัน',
      'D1': 'D1 - ค่าแรงรายวัน',
      'OV': 'OV - เงินได้เกินเพดานเงินเดือน',
      'P1': 'P1 - กองทุนสำรองเลี้ยงชีพ',
      'P2': 'P2 - กองทุนสำรองเลี้ยงชีพ(บริษัท)',
      'Q1': 'Q1 - ค่าจ้างนอกระบบ',
      'Q2': 'Q2 - Tax ภาษีค่าจ้างนอกระบบ',
      'R1': 'R1 - ตกเบิกเงินเดือน/ค่าแรง',
      'R2': 'R2 - ตกเบิกค่าครองชีพ',
      'R3': 'R3 - ตกเบิกค่าตำแหน่ง',
      'R4': 'R4 - ตกเบิกค่าบริหาร',
      'R5': 'R5 - ตกเบิกค่าเช่าบ้าน',
      'RA': 'RA - ตกเบิกค่าล่วงเวลา',
      'RB': 'RB - ตกเบิกหักลาเกิน',
      'RC': 'RC - ตกเบิกหักสาย',
      'RD': 'RD - ตกเบิกหักกลับก่อน',
      'RE': 'RE - ตกเบิกหักขาดงาน',
      'RF': 'RF - ตกเบิกค่าเบี้ยขยัน',
      'S1': 'S1 - ประกันสังคม',
      'S2': 'S2 - ประกันสังคม(บริษัท)',
      'S3': 'S3 - ประกันสังคม แบบตามจริง',
      'T0': 'T0 - ภาษีบริษัทออกให้',
      'T1': 'T1 - ภาษีเงินได้',
      'T2': 'T2 - ภาษีค่าล่วงเวลา',
      'T3': 'T3 - ภาษีค่าเบี้ยขยันรายเดือน หัก ณ.ที่จ',
      'T4': 'T4 - ภาษีค่ากะ',
      'T5': 'T5 - ภาษีจ้างทำของ',
      'T6': 'T6 - ภาษีค่าอยู่เวรพิเศษ (18)',
      'T7': 'T7 - ภาษีโบนัส',
      'T8': 'T8 - ภาษีค่า Commision',
      'T9': 'T9 - ภาษีค่านายหน้า',
      'TA': 'TA - Tax OT',
      'TB': 'TB - ภาษีรายได้อื่นๆ Cal.Tax',
      'TC': 'TC - ภาษีเงินปีใหม่',
      'TD': 'TD - ภาษีเงินได้จ่ายครั้งเดียว',
      'TE': 'TE - ภาษีค่าอยู่เวรพิเศษ',
      'TF': 'TF - ภาษีค่าความรู้พิเศษ (บริษัทออกให้)',
      'TG': 'TG - ภาษีตกเบิกค่าเบี้ยขยัน',
      'TH': 'TH - ภาษีเงินปีใหม่',
      'TI': 'TI - ภาษีตกเบิกเบี้ยขยัน',
      'TN': 'TN - ถาษีเงินได้จ่ายนอกระบบ',
      'TS': 'TS - ภาษีทดสอบ',
      'TT': 'TT - ภาษีเงินได้จาก Japan หัก ณ.ที่จ่าย',
      'TU': 'TU - ภาษีค่าเงินได้อื่นๆ-ญี่ปุ่น-tax(17)',
      'TW': 'TW - ภาษีค่าบ้านและค่าโรงเรียน(19)',
      'TZ': 'TZ - ภาษีหักขาดงาน',
      'W1': 'W1 - เงินสมทบประกันสังคม (บริษัท)',
      'W2': 'W2 - กองทุนเงินทดแทน',
      'W3': 'W3 - หักเงินสมทบประกันสังคม (บริษัท)',
      'W4': 'W4 - หักเงินสะสมกองทุนสำรองเลี้ยงชีพ (บร',
      'W5': 'W5 - เบี้ยประกันชีวิต',
      'W6': 'W6 - เบี้ยประกันสุขภาพ',
      'W7': 'W7 - คืนเงินค้ำประกันให้ลูกค้า',
      'WF': 'WF - กองทุนเงินทดแทน',
      'X1': 'X1 - เบี้ยกันดาร',
      'Z0': 'Z0 - ประกันสังคมบริษัทออกให้',
      'Z1': 'Z1 - ค่าครองชีพ',
      'Z2': 'Z2 - หักภาษีหัก ณ ที่จ่าย',
      'Z4': 'Z4 - ภาษีค่าอาหารบ.ออกให้ (14)',
      'Z5': 'Z5 - ภาษีค่าอาหาร บ.ออกให้ (15)',
      'Z6': 'Z6 - ภาษีค่าเบี้ยเลี้ยง ออกให้1ครั้ง(16)',
      'Z7': 'Z7 - ภาษีค่าเบี้ยขยันรายสัปดาห์',
      'Z8': 'Z8 - ภาษีค่าชำนาญการ',
      'Z9': 'Z9 - ภาษีรายได้อื่นๆ'
    }

    return {
      codpay: {
        en: mockCodpay,
        th: mockCodpay
      }
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtappr: '',
      typepay: '',
      dtepay: '',
      numperiod: '',
      dtemthpay: '',
      dteyrepay: '',
      codpay: '',
      flgssm: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word() + ' - ',
      desc_codempid: faker.name.findName(),
      approvno: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtappr: faker.commerce.price(),
      typepay: '1',
      dtepay: moment().format('DD/MM/YYYY'),
      numperiod: '2',
      dtemthpay: moment().format('DD/MM/YYYY'),
      dteyrepay: moment().format('DD/MM/YYYY'),
      codpay: 'TS',
      staappr: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres85u/mocker.js